import {combineReducers} from '@reduxjs/toolkit';
import compare from './compare.js';
import featureCollections from './featureCollections.ts';
import quotaManagement from './quotaManagement.ts';

const combinedReducers = combineReducers({
  compare,
  featureCollections,
  quotaManagement,
});

export default combinedReducers;
